/* jshint node:true */
'use strict';

var React = require('react');

/* Components */
var LeagueTable         = require('./LeagueTable.jsx');
var NewsList            = require('./NewsList.jsx');
var utils = require('../../../helpers/utils/index.js');

var TabTable = React.createClass({

    displayName: 'TabTable',

    render: function () {

        var sState = this.props.matchState || 'pre'; //pre,post,live
        var oStore = this.props.store;
        var rSummary = null;
        
        /* Load in the data from the Store */
        var aLeagueTable = oStore.getLeagueTable();
        var leagueName = oStore.getLeagueName();
        var newsList = oStore.getNewsList();
        var gameStripProps = oStore.getGameStripDetails();
        var homeLogo = utils.getImageUrl(gameStripProps.teams.home.logo);
        var awayLogo = utils.getImageUrl(gameStripProps.teams.away.logo);
        var homeTeam = {logo: homeLogo, abbreviation: gameStripProps.teams.home.abbreviation};
        var awayTeam = {logo: awayLogo, abbreviation: gameStripProps.teams.away.abbreviation};
        
        if(sState === 'post'){
            rSummary = (
                <div className="layout-bc">
                    <section className="col-b">
                        <article className="sub-module">
                            <header className="bordered">
						        <h1>Table</h1>
					        </header>    
                        </article>
                    </section>
                    <section className="col-c">
                        <LeagueTable date="" name={leagueName} table={aLeagueTable} />
                        <NewsList header={newsList.header} link={newsList.link} articles={newsList.articles} />
                    </section>
                </div>
            );

        }else if(sState === 'live'){

            rSummary = (
                <div className="layout-cbc">
                    <section className="col-one">
                    </section>
                    <section className="col-two">
                    </section>
                    <section id="now-feed" className="col-three">
                        <LeagueTable date="" name={leagueName} table={aLeagueTable} />
                        <NewsList header={newsList.header} link={newsList.link} articles={newsList.articles} />
                    </section>
                </div>
            );

        }else{

            rSummary = (
                <div className="layout-bc">
                    <section className="col-b">
                    </section>
                    <section className="col-c">
                        <LeagueTable date="" name={leagueName} table={aLeagueTable} />
                        <NewsList header={newsList.header} link={newsList.link} articles={newsList.articles} />
                    </section>
                </div>
            );
        }

        return rSummary;
    }
});

module.exports = TabTable;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/TabTable.jsx
 **/